import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { withJwt } from '../../../utils/with-jwt';
import { ignoreData } from '../../../utils/ignore-data';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { AssetInvitationType } from '../schemas/asset-invitation-type.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Invite a single User to a specified Product
 * @param id User's ID
 * @param productId Product's ID
 * @param invitationType Asset Invitation Type
 */
export function postUsersInvite(
  this: unknown,
  id: number,
  productId: number,
  invitationType?: AssetInvitationType
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).usersUrl}/invite`, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
        body: JSON.stringify({
          id,
          productId,
          invitationType,
        }),
      })
    )
  ).pipe(ignoreData());
}
